import { createAction, props } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';
import {
    CreateReferralsRequest,
    ReferralsRequestRequest,
} from '../../models/api/requests/referrals.request';

export const FETCH_REFERRALS_REQUESTS = '[Wallet] Fetch referrals requests';
export const FETCH_REFERRALS_REQUESTS_SUCCESS =
    '[Referrals] Fetch referrals requests success';
export const FETCH_REFERRALS_REQUESTS_FAILURE =
    '[Referrals] Fetch referrals requests failure';

export const CREATE_REFERRALS_REQUEST = '[Referrals] Create referrals request';
export const CREATE_REFERRALS_REQUEST_SUCCESS =
    '[Referrals] Create referrals request success';
export const CREATE_REFERRALS_REQUEST_FAILURE =
    '[Referrals] Create referrals request failure';

export const UPDATE_REFERRALS_REQUEST = '[Referrals] Update referrals request';
export const UPDATE_REFERRALS_REQUEST_SUCCESS =
    '[Referrals] Update referrals request success';
export const UPDATE_REFERRALS_REQUEST_FAILURE =
    '[Referrals] Update referrals request failure';

export const fetchReferralsRequests = createAction(
    FETCH_REFERRALS_REQUESTS,
    props<{
        id?: string;
        isActive?: boolean;
        includeExpired: boolean;
        includeNonBillableActions: boolean;
    }>()
);

export const fetchReferralsRequestsSuccess = createAction(
    FETCH_REFERRALS_REQUESTS_SUCCESS,
    props<{
        payload: {
            items: any;
        };
    }>()
);

export const fetchReferralsRequestsFailure = createAction(
    FETCH_REFERRALS_REQUESTS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const createReferralsRequest = createAction(
    CREATE_REFERRALS_REQUEST,
    props<{
        payload: CreateReferralsRequest;
    }>()
);

export const createReferralsRequestSuccess = createAction(
    CREATE_REFERRALS_REQUEST_SUCCESS,
    props<{
        payload: {
            request: any;
        };
    }>()
);

export const createReferralsRequestFailure = createAction(
    CREATE_REFERRALS_REQUEST_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const updateReferralsRequest = createAction(
    UPDATE_REFERRALS_REQUEST,
    props<{
        payload: {
            id: string;
            expiresAt: string;
            isActive: boolean;
        };
    }>()
);

export const updateReferralsRequestSuccess = createAction(
    UPDATE_REFERRALS_REQUEST_SUCCESS,
    props<{
        payload: {
            request: any;
        };
    }>()
);

export const updateReferralsRequestFailure = createAction(
    UPDATE_REFERRALS_REQUEST_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
